import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./Card.css";

const Card = ({ comic, addToWhistlist }) => {
  return (
    <div className="card">
      <div className="card-top">
        <img src={comic.cover} alt={comic.title} />
      </div>
      <div className="card-body">
        <h3>{comic.title}</h3>
        <p>
          <strong>Release Date:</strong> {comic.releaseDate}
        </p>
        <p>
          <strong>Author:</strong> {comic.Author}
        </p>
        <p>
          <strong>Language:</strong> {comic.language}
        </p>
        <p>
          <strong>Price:</strong> ${comic.price}
        </p>
      </div>

      <div className="card-footer">
        <button onClick={() => addToWhistlist(comic)}>
          <FontAwesomeIcon icon={faPlus} /> Add to Whistlist
        </button>
      </div>
    </div>
  );
};

export default Card;
